import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';

export default function PushSettings__Granted (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [translateGui] = useGuiTranslations();

    return (
        <div className={classes.root}>
         <div className={classes.wrapper}>
            <div className={classes.messageDiv}>
            {capitalizeFirstLetter(translateGui(130))}
            </div>
            <img className={classes.image}  src={window.location.origin + '/notif_ornek.png'} />
        </div>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
      display:'flex',
      justifyContent: 'center',  
    },
    messageDiv:{
        margin: '30px 0',
    },
    wrapper:{
        width: '80%',
    },
    imageWrapper: {
        display: 'flex',
        justifyContent: 'center',
    },
    image:{
        width: '70%',

        '@media (max-width:600px)':{
            width: '100%',
        }
    }
});